<a [href]="data.url" target="_blank" class="usefull-link" *ngIf="data">
  <div class="usefull-link__image">
    <brt-image [image]="data.image"></brt-image>
  </div>

  <div class="usefull-link__content">
    <div class="usefull-link__title">{{data.title}}</div>
    <div class="usefull-link__description">{{data.description}}</div>
  </div>
</a>
